import React from 'react';

import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import ScheduleSendOutlinedIcon from '@mui/icons-material/ScheduleSendOutlined';
import homePageV2Messages from './assets/messages/homePageMessages';
import { getFormattedMessage } from '../utils/textUtils';


export const physicalHighlightBulletLists = (intl) => {
    

    const bulletText = [
        {
            icon: <ImageOutlinedIcon />,
            text: getFormattedMessage(intl, homePageV2Messages.physicalDescriptionBullet3)
        },
        {
            icon: <ScheduleSendOutlinedIcon />,
            text: getFormattedMessage(intl, homePageV2Messages.physicalDescriptionBullet1)
        },
        {
            icon: <LocalShippingOutlinedIcon />,
            text: getFormattedMessage(intl, homePageV2Messages.physicalDescriptionBullet2)
        }
    ];

    
    const sortedPhysicalHighlightBulletList = bulletText.filter(item => item.text.trim() !== '');

    return sortedPhysicalHighlightBulletList;
};
